"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowRight = function ArrowRight() {
  return _react2.default.createElement(
    "g",
    { id: "arrow-right", transform: "translate(111.000000, 1.000000)" },
    _react2.default.createElement("polygon", { id: "Shape", points: "58.4988962 0 0 58.4988962 191.501104 250 0 441.501104 58.4988962 500 308.498896 250" })
  );
};

exports.default = ArrowRight;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/ArrowRight.js
// module id = 2925
// module chunks = 4